/**
 * TreatmentTypeDropdown Component
 *
 * Reusable dropdown component for treatment status selection.
 * Handles individual, group, and discharge treatment types.
 */

import React, { memo } from 'react';
import FormInputDropdown from '../../common/Forms/FormDropdown';
import { TREATMENT_TYPES } from '../utils/verificationConstants';

/**
 * TreatmentTypeDropdown Component
 *
 * @param {Object} props - Component props
 * @param {string} props.name - Field name for the dropdown
 * @param {Object} props.control - React Hook Form control object
 * @param {Function} props.register - React Hook Form register function
 * @param {string} props.label - Label for the dropdown
 * @param {Array} props.options - Dropdown options array
 * @param {boolean} props.disabled - Whether dropdown is disabled
 * @param {Function} props.onChange - Change handler function
 * @param {string} props.treatmentType - Type of treatment (INDIVIDUAL, GROUP, DISCHARGE)
 * @returns {JSX.Element} TreatmentTypeDropdown component
 */
const TreatmentTypeDropdown = ({
  name,
  control,
  register,
  label,
  options,
  disabled = false,
  onChange,
  treatmentType,
}) => {
  // Determine if this is a discharge dropdown
  const isDischargeType = treatmentType === TREATMENT_TYPES.DISCHARGE;

  return (
    <FormInputDropdown
      name={name}
      control={control}
      label={label}
      shrink={true}
      options={options}
      disabled={disabled}
      getIdValue={true}
      verifyDischarge={isDischargeType}
      register={register(name, {
        onChange: (e) => {
          if (onChange) {
            onChange(e);
          }
        },
      })}
    />
  );
};

export default memo(TreatmentTypeDropdown);
